module.exports = __webpack_public_path__ + "assets/images/team/Fahriddin1.jpg";